var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#F6BB42",
  d: "M17.68 8.928h-2.852c0-1.67-.67-3.183-1.754-4.277l2.016-2.036c1.6 1.615 2.59 3.847 2.59 6.313z",
  transform: "translate(-365 -1131) translate(40 1062) translate(153 37) translate(149 32) translate(23.762 .5)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8CC152",
  d: "M14.828 8.928h2.851c0 2.462-.986 4.694-2.589 6.31l-2.016-2.033c1.084-1.095 1.754-2.607 1.754-4.277z",
  transform: "translate(-365 -1131) translate(40 1062) translate(153 37) translate(149 32) translate(23.762 .5)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#37BC9B",
  d: "M15.09 15.238v.003c-1.6 1.615-3.807 2.615-6.25 2.615v-2.88c1.653 0 3.15-.677 4.234-1.771l2.016 2.033z",
  transform: "translate(-365 -1131) translate(40 1062) translate(153 37) translate(149 32) translate(23.762 .5)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E9573F",
  d: "M15.09 2.615l-2.016 2.036C11.99 3.557 10.494 2.88 8.84 2.88V0c2.443 0 4.65 1 6.25 2.615z",
  transform: "translate(-365 -1131) translate(40 1062) translate(153 37) translate(149 32) translate(23.762 .5)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFCE54",
  d: "M14.828 8.928H11.976c0-.876-.35-1.668-.918-2.24l2.016-2.037c1.084 1.094 1.754 2.606 1.754 4.277z",
  transform: "translate(-365 -1131) translate(40 1062) translate(153 37) translate(149 32) translate(23.762 .5)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#48CFAD",
  d: "M11.058 11.168l2.016 2.037c-1.084 1.094-2.58 1.771-4.234 1.771v-2.88c.866 0 1.65-.354 2.218-.928z",
  transform: "translate(-365 -1131) translate(40 1062) translate(153 37) translate(149 32) translate(23.762 .5)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4A89DC",
  d: "M8.84 14.976v2.88c-2.441 0-4.651-1-6.25-2.615l2.015-2.036c1.084 1.094 2.584 1.771 4.235 1.771z",
  transform: "translate(-365 -1131) translate(40 1062) translate(153 37) translate(149 32) translate(23.762 .5)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5D9CEC",
  d: "M8.84 12.096v2.88c-1.651 0-3.151-.677-4.235-1.771l2.016-2.036c.568.573 1.355.927 2.219.927z",
  transform: "translate(-365 -1131) translate(40 1062) translate(153 37) translate(149 32) translate(23.762 .5)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ED5565",
  d: "M8.84 2.88v2.88c-.864 0-1.649.354-2.216.927h-.003L4.605 4.651C5.69 3.557 7.19 2.88 8.84 2.88z",
  transform: "translate(-365 -1131) translate(40 1062) translate(153 37) translate(149 32) translate(23.762 .5)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#967ADC",
  d: "M4.605 13.205L2.59 15.24C.99 13.625 0 11.393 0 8.928h2.851c0 1.67.67 3.182 1.754 4.277z",
  transform: "translate(-365 -1131) translate(40 1062) translate(153 37) translate(149 32) translate(23.762 .5)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A0D468",
  d: "M11.98 8.928h2.848c0 1.67-.67 3.182-1.754 4.277l-2.016-2.036c.568-.573.918-1.369.918-2.241h.003z",
  transform: "translate(-365 -1131) translate(40 1062) translate(153 37) translate(149 32) translate(23.762 .5)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EC87C0",
  d: "M4.605 4.65l2.016 2.037c-.567.573-.918 1.365-.918 2.241H2.851c0-1.67.67-3.183 1.754-4.277z",
  transform: "translate(-365 -1131) translate(40 1062) translate(153 37) translate(149 32) translate(23.762 .5)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#AC92EC",
  d: "M6.621 11.168l-2.016 2.037c-1.083-1.095-1.754-2.607-1.754-4.277h2.852c0 .872.35 1.668.918 2.24z",
  transform: "translate(-365 -1131) translate(40 1062) translate(153 37) translate(149 32) translate(23.762 .5)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D770AD",
  d: "M2.59 2.615l2.015 2.036C3.522 5.745 2.851 7.257 2.851 8.928H0C0 6.462.99 4.23 2.59 2.615z",
  transform: "translate(-365 -1131) translate(40 1062) translate(153 37) translate(149 32) translate(23.762 .5)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC6E51",
  d: "M13.074 4.65l-2.016 2.037c-.567-.573-1.352-.927-2.218-.927V2.88c1.653 0 3.15.677 4.234 1.77z",
  transform: "translate(-365 -1131) translate(40 1062) translate(153 37) translate(149 32) translate(23.762 .5)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DA4453",
  d: "M8.84 0v2.88c-1.651 0-3.151.677-4.235 1.77L2.59 2.616C4.19.999 6.4 0 8.84 0z",
  transform: "translate(-365 -1131) translate(40 1062) translate(153 37) translate(149 32) translate(23.762 .5)"
})))))));

function SvgMulticolorCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMulticolorCircle);
export default __webpack_public_path__ + "static/media/multicolor-circle.02dd53d5.svg";
export { ForwardRef as ReactComponent };